import api from './api'
import type { EmployeeCourse } from './courseService'

// Types
export type DashboardStats = {
  totalEmployees?: number
  activeEmployees?: number
  inactiveEmployees?: number
  totalLessons: number
  totalExams: number
  passedExams: number
  failedExams: number
  skippedExams: number
  totalLessonAssignments?: number
  completedLessonAssignments?: number
  inProgressLessonAssignments?: number
  notStartedLessonAssignments?: number
  currentExams?: number
  upcomingExams?: number
}

export type Activity = {
  id: number | string
  description: string
  timestamp: string
  type: string
  email?: string
  first_name?: string
  last_name?: string
  status?: string
}

export type Exam = {
  id: string
  title: string
  date: string
  status: 'Upcoming' | 'Completed' | 'Skipped'
}

export interface DashboardResponse {
  success: boolean
  data: DashboardStats
}

export interface ActivityResponse {
  success: boolean
  data: Activity[]
}

export const dashboardApi = {
  /**
   * Get dashboard statistics
   */
  getStats: async (): Promise<DashboardStats> => {
    try {
      const response = await api.get<DashboardResponse>('/dashboard/stats')
      return response.data.data
    } catch (error) {
      console.error('Dashboard stats API error:', error)
      throw error
    }
  },

  /**
   * Get recent activity
   */
  getRecentActivity: async (): Promise<Activity[]> => {
    try {
      const response = await api.get<ActivityResponse>('/dashboard/activity')
      return response.data.data
    } catch (error) {
      console.error('Dashboard activity API error:', error)
      throw error
    }
  },

  /**
   * Get employee available courses with progress.
   */
  getEmployeeCourses: async (): Promise<EmployeeCourse[]> => {
    try {
      const response = await api.get<{ success: boolean; data: EmployeeCourse[] }>('/dashboard/employee-courses')
      return response.data.data
    } catch (error) {
      console.error('Employee courses API error:', error)
      throw error
    }
  },

  /**
   * Get exams
   */
  getExams: async (): Promise<Exam[]> => {
    return []
  }
}
